import formValueSelector from 'redux-form/es/formValueSelector';
import { formatMsisdnAU } from 'utils/helpers';
import { FORM_NAMES } from 'consts/formNames';

const selector = formValueSelector(FORM_NAMES.UPDATE_DATA);

export const mapStateToProps = (state) => {
  const {
    authentication: {
      email,
      emailPending,
      msisdn,
      msisdnPending,
      address: {
        street,
        floor,
        door,
        city,
        province,
        postcode,
      },
    },
  } = state;

  return {
    initialValues: {
      email: emailPending ? emailPending : email,
      msisdn: formatMsisdnAU(msisdnPending || msisdn),
      street,
      floor,
      door,
      city,
      province,
      postcode,
    },
    msisdn: selector(state, 'msisdn'),
  };
};
